import React from "react"

import { Avatar, Icon, Popover } from 'antd'
import {Link} from "actb"

export default function Idea(props){
    const {title, style, children, more, ...other} = props
    // const content =  (
    //     <Card 
    //     className="side-note" 
    //     title={<span><Icon type="bulb"/>&nbsp;{title}</span>} 
    //     extra={<Link to={more}>More</Link>} 
    //     style={{ width: 300, float:"right", ...(style || {}) }}
    //     {...other}
    //     >
    //         {children}
    //     </Card>
    // )
    const action = more? (<Link to={more} style={{float:"right"}} title={title}>More</Link>):null
    const popoverTitle = (
    <div style={{width:"100%"}}>
        <span><Icon type="bulb"/>&nbsp;{title}</span>
        {action}
    </div>
    )
    return (
        <span style={{ float:"right", position:"relative"}}>
            <Popover
            title={popoverTitle}
            content={children}
            {...other}
            >
                <Avatar style={{backgroundColor:"#ff6090"}}>
                    <Icon type="bulb"/>
                </Avatar>
            </Popover>
        </span>
    )
}